import Head from "next/head";

export const renderMetaTags = (data: any) => {
  const { meta_title, meta_desc, meta_image, og_meta, noIndexNoFollow } =
    data || {};
  const metaTitle =
    meta_title || "Shyft - Clean and Minimal Nutrition Supplements";
  const metaDescription =
    meta_desc ||
    "Built on simplicity and transparency. Clean, short ingredient lists with no fillers, no harmful additives - just performance";
  const metaImage =
    meta_image ||
    "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png";
  const canonicalURL = og_meta?.canonical_url;

  return (
    <>
      <Head>
        {metaTitle && <title>{metaTitle}</title>}
        {metaDescription && (
          <meta name="description" content={metaDescription} />
        )}
        <meta
          name="og:image"
          property="og:image"
          content={
            metaImage ||
            "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png"
          }
          key="og:image"
        />

        <meta name="description" content={metaDescription} key="description" />
        <meta property="og:locale" content="en_US" key="og:locale" />
        <meta property="og:type" content="website" key="og:type" />
        <meta property="og:title" content={metaTitle} key="og:title" />
        <meta
          property="og:description"
          content={metaDescription}
          key="og:description"
        />
        <meta property="og:url" content={canonicalURL} key="og:url" />
        <meta property="og:site_name" content="Shyft" key="og:site_name" />
        <meta
          name="twitter:card"
          content="summary_large_image"
          key="twitter:card"
        />
        {canonicalURL && (
          <link rel="canonical" href={canonicalURL} key="canonical" />
        )}
        {/* TODO: provide data for noIndexNoFollow */}
        {noIndexNoFollow && <meta name="robots" content="noindex, nofollow" />}
      </Head>
    </>
  );
};

export const renderMetaData = ({
  siteName = "Shyft",
  siteURL = "https://www.betheshyft.com/",
  title = "Shyft - Health & Wellness Platform | Shyft Health",
  description = "At Shyft we are committed to creating products and services of the highest quality leading to maximum impact.",
  thumbnail = "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
  h1Text = null,
  pageTitle = title,
  pageDescription = description,
}: any) => {
  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {siteURL && <meta property="og:url" content={siteURL} />}
        {siteName && <meta property="og:site_name" content={siteName} />}
        <meta property="og:image" content={thumbnail} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      {h1Text && <h1 style={{ display: "none" }}>{h1Text}</h1>}
    </>
  );
};
